export const PARTNERS_RESET_STATE = 'PARTNERS_RESET_STATE';
export const PARTNERS_CURRENT_ITEM = 'PARTNERS_CURRENT_ITEM';

export const PARTNERS_REQUEST_LOADING = 'PARTNERS_REQUEST_LOADING';
export const PARTNERS_REQUEST_SUCCESS = 'PARTNERS_REQUEST_SUCCESS';
export const PARTNERS_REQUEST_FAILED = 'PARTNERS_REQUEST_FAILED';

export const PARTNERS_CURRENT_ACTION = 'PARTNERS_CURRENT_ACTION';
export const PARTNERS_RESET_ACTION = 'PARTNERS_RESET_ACTION';